import { maxTextLines } from 'Shared/frontend/Poster';
import { css } from '@emotion/css';
import { Show } from 'solid-js';
import { palette } from 'Shared/frontend/SettingsProvider';
import { DateWrap } from 'Shared/frontend/eventPosters/FallbackMusicPoster';


export function FallbackNonMusicPoster(P)
{
	/* Drawn inside the space the poster was given rather than around it: '100%' against the global
	   border-box leaves the frame's own size untouched. */
	const borderStyle = () => css({
		width: '100%',
		height: '100%',
		border: `6px dotted ${palette().feature}`
	});

	const posterStyle = () => css({
		margin: '24px 0.2em 0 0.2em',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		gap: 14,
		textAlign: 'center',
		color: palette().text
	});

	const eventNameStyle = () => css({
		textTransform: 'uppercase',
		padding: '.5em 0 .5em 0',
		width: '100%',
		...maxTextLines(3),
		fontSize: 24
	});

	const descriptionStyle = () => css({
		lineHeight: '1.2em',
		textAlign: 'center',
		padding: '0 0.5em',
		width: '100%',
		...maxTextLines(6),
		fontSize: 15 
	});

	return (
		<div class={borderStyle()}>
			<DateWrap {...P}>
				<div class={posterStyle()}>
					<Show when={P.name}>
						<div class={eventNameStyle()}>{ P.name }</div>
					</Show>

					<Show when={P.tagline}>
						<div class={descriptionStyle()}>{ P.tagline }</div>
					</Show>
				</div>
			</DateWrap>
		</div>
	);
}
